import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import {Table, Popover, Modal, Dropdown, Whisper} from 'rsuite';
import {useHistory} from "react-router-dom";
import {gql, useMutation} from "@apollo/client";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronCircleDown} from "@fortawesome/free-solid-svg-icons";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import './CotizacionesTable.css'
import 'rsuite/dist/styles/rsuite-default.css'
import AdviserContext from "../../../context/AdviserContext";
import {makeStyles} from "@material-ui/core/styles";
import EncodeSansLight from "../../../assets/fonts/Encode_Sans/EncodeSans-Light.ttf";
import CotizarContext from "../../../context/CotizarContext";
import {Button} from "@material-ui/core";
import {Form, Formik} from "formik";
import axios from "axios";
import AuthContext from "../../../context/AuthContext";
import CustomModal from "../../Formularios/FormikUtils/CustomModal";
import white_others_icon from "../../../assets/images/white_others_icon.png";
import prevencion_white_icon from "../../../assets/images/prevencion_white_icon.png";
import ProgressBar from "../../customer/ProductsCustomer/ProgressBar";
import Loading from "../../Loading"

import validationSchema from '../../Formularios/Emision/OtrosForm/Checkout/FormModel/validationSchema';
import formModel from "../../Formularios/Emision/OtrosForm/Checkout/FormModel/formModel"
import formInitialValues from "../../Formularios/Emision/OtrosForm/Checkout/FormModel/formInitialValues";
import PolizaForm from "../../Formularios/Emision/OtrosForm/Checkout/Forms/PolizaForm";
import ClienteForm from "../../Formularios/Emision/OtrosForm/Checkout/Forms/ClienteForm";

import validationSchemaPrevencion from '../../Formularios/Emision/PrevencionForm/Checkout/FormModel/validationSchema';
import formModelPrevencion from "../../Formularios/Emision/PrevencionForm/Checkout/FormModel/formModel"
import formInitialValuesPrevencion from "../../Formularios/Emision/PrevencionForm/Checkout/FormModel/formInitialValues";
import PolizaFormPrevencion from "../../Formularios/Emision/PrevencionForm/Checkout/Forms/PolizaForm";
import ClienteFormPrevencion from "../../Formularios/Emision/PrevencionForm/Checkout/Forms/ClienteForm";

import ArrowDropDownCircleIcon from "@material-ui/icons/ArrowDropDownCircle";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField/TextField";
import IndicatorsContext from "../../../context/AdviserContext/IndicatorsContext";
import IconButton from "@mui/material/IconButton";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import {DateRangePicker} from 'react-date-range';
import * as locales from 'react-date-range/dist/locale';
import {CurrencyFormat} from "../../utils/CurrencyFormat";
import sortRowsByType from './utils/sortRowsByType';

const {formId, formField} = formModel;
const {formFieldPrevencion} = formModelPrevencion;

const useStyles = makeStyles(theme => ({
    centerVertically: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
    },
    endHorizontally: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "flex-end",
        alignItems: "center",
    },
    tableTitle: {
        fontFamily: "EncodeSansBold",
        fontSize: "20px",
        color: "#3b3b3b",
    },
    tableHeader: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        margin: '16px 16px'
    },
    iconCircle: {
        clipPath: "circle(25px at 50% 50%)",
        background: "#bb0d66",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "-50px",
        height: "50px"
    },
    alertField: {
        '& label.Mui-focused': {
            color: "#BB0D66",
        },
    },
    shareButton: {
        borderRadius: "20px",
        color: "#fff",
        fontSize: "12px",
        background: "#BB0D66",
        padding: "4px 8px 4px 8px",
        marginLeft: "2px",
        marginRight: "2px",
        textDecoration: "none",
        border: "solid #BB0D66 0px",
        fontFamily: EncodeSansLight,
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    buttons: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        width: "100%",
        marginTop: "32px"
    },
    modalColumn: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly"
    },
    modalSubtitle: {
        fontFamily: "Poppins",
        fontWeight: "500",
        fontSize: "20px",
        textAlign: 'center',
        marginTop: "16px"
    },
    modalText: {
        fontFamily: "Poppins",
        fontWeight: "400",
        fontSize: "16px",
        marginTop: "-4px",
        textAlign: 'center'
    },
    btnShare: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "14px",
        background: "#BB0D66",
        padding: "10px 30px 10px 30px",
        margin: "10px 5px -10px 5px",
        textDecoration: "none",
        border: "solid #BB0D66 0px",
        fontFamily: EncodeSansLight,
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    buttonConfirm: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    buttonCancel: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#9A9A9A",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    btnCancel: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "14px",
        backgroundColor: "#9A9A9A",
        padding: "10px 30px 10px 30px",
        margin: "10px 5px -10px 5px",
        textDecoration: "none",
        border: "solid #BB0D66 0px",
        fontFamily: EncodeSansLight,
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    modalTitle: {
        fontFamily: "Poppins",
        fontWeight: '500',
        fontSize: "20px",
        marginBottom: "16px",
        color: "#bb0d66",
        textAlign: "center"
    },
    alertSubTitle: {
        fontFamily: "EncodeSansBold",
        color: "#000",
        lineHeight: 0.5,
        fontSize: "16px"
    },
    alertText: {
        fontFamily: "EncodeSansRegular",
        color: "#000",
        fontSize: "16px",
        textAlign: "center"
    },
    modalRow: {
        padding: "4px",
        display:"flex",
        justifyContent:"center"
    },
    buttonModalContainer: {
        margin: "8px 0 -16px"
    },
    dateRangeTitle: {
        backgroundColor: "rgb(239, 242, 247)",
        fontSize: '12px',
        fontFamily: 'Nunito',
        letterSpacing: '-0.75',
        color:"#849095",
        textAlign: "center",
        paddingTop: "8px"
    }
}))

const Mailto = ({email, subject = '', body = '', children}) => {
    let params = subject || body ? '?' : '';
    if (subject) params += `subject=${encodeURIComponent(subject)}`;
    if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

    return <a href={`mailto:${email}${params}`}>{children}</a>;
};

const sendWapp = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
}

const {Column, HeaderCell, Cell, Pagination} = Table;

const QUITAR_COTIZACION_COMBINADO = gql`
    mutation MyMutation($id: Int) {
        update_CombinadoFamiliar_Cotizaciones(where: {id: {_eq: $id}}, _set: {Show: false}) {
            affected_rows
        }
    }`;
const QUITAR_COTIZACION_MICROSEGURO = gql`
    mutation MyMutation($id: Int) {
        update_Microseguros_Cotizaciones(where: {id: {_eq: $id}}, _set: {Show: false}) {
            affected_rows
        }
    }`;
const QUITAR_COTIZACION_MOTOVEHICULO = gql`
    mutation MyMutation($id: Int) {
      update_Motovehiculo_Cotizaciones(where: {idCotizacion: {_eq: $id}}, _set: {Show: false}) {
        affected_rows
      }
    }
`;
const QUITAR_COTIZACION_AUTOMOTOR = gql`
    mutation MyMutation($id: Int) {
  update_Autos_Cotizacion(where: {idCotizacion: {_eq: $id}}, _set: {Show: false}) {
    affected_rows
  }
}`;
const QUITAR_COTIZACION_OTROS = gql`
    mutation MyMutation($id: Int) {
  update_Otros_Clientes_Precotizaciones_Otros(where: {id: {_eq: $id}}, _set: {Show: false}) {
    affected_rows
  }
}`;
const QUITAR_COTIZACION_PREVENCION = gql`
mutation MyMutation($id: Int) {
  update_PrevencionSalud_Clientes_Precotizaciones_PrevencionSalud(where: {id: {_eq: $id}}, _set: {show: false}) {
    affected_rows
  }
}`;

const ClienteCell = ({rowData, dataKey, ...props}) => {
    let speaker;
    if (rowData['Clientes'] !== null) {

        switch (rowData['producto']) {
            case "OTROS":
                speaker = (
                    <Popover title="Más información" style={{maxWidth:"400px", maxHeight: "256px", overflowY: "auto", whiteSpace: "pre-wrap"}}>
                        <p>DNI: {rowData['Clientes']['DNI']} </p>
                        <p>Celular: {rowData['Clientes']['CodArea'] + rowData['Clientes']['Telefono']} </p>
                        <p>Email: {rowData['Clientes']['Email']} </p>
                        {rowData['Comentario'] !== null &&
                            <p>Comentarios: {rowData['Comentario']} </p>
                        }
                        {rowData['ArchivosPrecotizacion'].length !== 0 &&
                        <>
                            <p>Archivos:</p>
                            <ul>
                                {rowData['ArchivosPrecotizacion'].map((archivo) => (
                                    <li><a href={archivo.link} target="_blank">{archivo.link.split("/")[archivo.link.split("/").length - 1]}</a></li>
                                ))}
                            </ul>
                        </>
                        }
                    </Popover>
                )
                break;
            case "PREVENCION SALUD":
                speaker = (
                    <Popover title="Más información" style={{maxWidth:"400px", maxHeight: "256px", overflowY: "auto", whiteSpace: "pre-wrap"}}>
                        <p>DNI: {rowData['Clientes']['DNI']} </p>
                        <p>Celular: {rowData['Clientes']['CodArea'] + rowData['Clientes']['Telefono']} </p>
                        <p>Email: {rowData['Clientes']['Email']} </p>
                        {rowData['ArchivosPrecotizacion'].length !== 0 &&
                        <>
                            <p>Archivos:</p>
                            <ul>
                                {rowData['ArchivosPrecotizacion'].map((archivo) => (
                                    <li><a href={archivo.link} target="_blank">{archivo.link.split("/")[archivo.link.split("/").length - 1]}</a></li>
                                ))}
                            </ul>
                        </>
                        }
                    </Popover>
                )
                break;
            case "AUTOMOTOR":
                speaker = (
                    <Popover title="Más información">
                        <p>DNI: {rowData['Clientes']['DNI']} </p>
                        <p>Patente: {rowData['Clientes']['Patente']} </p>
                    </Popover>
                )
                break;
            default:
                //Cases "HOGAR" && "MICROSEGURO" are both the same
                speaker = (
                    <Popover title="Más información">
                        <p>DNI: {rowData['Clientes']['DNI']} </p>

                        {/*TODO: Remove conditional, the right one will be the one with splitted field*/}
                        {(rowData['Clientes']['CodArea'] !== null && rowData['Clientes']['CodArea'] !== undefined)
                            ? <p>Celular: {rowData['Clientes']['CodArea'] + rowData['Clientes']['Telefono']} </p>
                            : <p>Celular: {rowData['Clientes']['Telefono']} </p>
                        }

                        <p>Email: {rowData['Clientes']['Email']} </p>
                    </Popover>
                )
                break;
        }
    }
    return (
        <Cell {...props}>
            {rowData['Clientes'] !== null ?
                <Whisper placement="rightStart" speaker={speaker} enterable >
                    <a>{rowData[dataKey].toLocaleString()}</a>
                </Whisper>
                :
                rowData[dataKey].toLocaleString()
            }
        </Cell>
    );
};


const cargaFamiliaDict = {
    '0': 'Individual',
    '1': 'Matrimonio'
};

const numeroHijosDict = {
    0: 'Sin hijos',
    1: '1 hijo',
    2: '2 hijos',
    3: '3 hijos',
    4: '4 hijos',
    5: '5 hijos',
    6: 'Más de 5 hijos'
};

const condicionLaboralDict = {
    '0': 'Empleado',
    '1': 'Autónomo'
};

const columnType = {
    "FechaCotizacion": "date",
    "FechaModificacion": "date",
    "Estado": "status",
}

const NameCell = ({rowData, dataKey, coberturasInfo, ...props}) => {
    let speaker;
    if (rowData['producto'] === 'HOGAR') {
        let dict = {};
        coberturasInfo.map((item) =>
            dict[item.NumeroCobertura] = {
                sumaChica: item.SumaChica,
                sumaMediana: item.SumaMediana,
                sumaGrande: item.SumaGrande,
                sumaMaxima: item.SumaMaxima,
                sumaMinima: item.SumaMinima,
                descripcion: item.Descripcion,
                descripcionCompleta: item.DescripcionCompleta,
            });
        let forEachData = '';
        rowData['coberturas'].forEach(d => {
            forEachData += `<li>${dict[d.numeroCobertura].descripcion}` + ': $' + `${d.sumaAsegurada.toLocaleString('es-AR')}`
        })

        speaker = (
            <Popover title="Más información">
                <p>Tamaño vivienda: {rowData['tamanioVivienda']}</p>
                <>
                    <p>Coberturas:</p>
                    <ul dangerouslySetInnerHTML={{__html: forEachData}}/>
                </>
            </Popover>
        )

        return (
            <Cell {...props}>
                <Whisper placement="rightStart" speaker={speaker} enterable>
                    <a>{rowData[dataKey].toLocaleString()}</a>
                </Whisper>
            </Cell>
        )
    }

    if (rowData['producto'] === 'PREVENCION SALUD') {
        speaker = (
            <Popover title="Más información">
                <ul>
                    <li><span style={{fontWeight: "700"}}>Condición Laboral: </span>{condicionLaboralDict[rowData['condicion_laboral']]}</li>
                    <li><span style={{fontWeight: "700"}}>Carga Familiar: </span>{cargaFamiliaDict[rowData['carga_familiar']]}</li>
                    <li><span style={{fontWeight: "700"}}>Número de Hijos: </span>{numeroHijosDict[rowData['cantidad_hijos']]}</li>
                    <li><span style={{fontWeight: "700"}}>Monto Bruto: </span>$ {CurrencyFormat(rowData['monto_bruto'])}</li>
                </ul>
            </Popover>
        )

        return (
            <Cell {...props}>
                <Whisper placement="rightStart" speaker={speaker} enterable>
                    <a>{rowData[dataKey].toLocaleString()}</a>
                </Whisper>
            </Cell>
        )
    }

    return (
        <Cell {...props}>
            {rowData[dataKey].toLocaleString()}
        </Cell>
    );
};

function _renderStepContent(activeStep, rowDataConfirm) {
    switch (activeStep) {
        case 0:
            return <PolizaForm formField={formField}/>
        case 1:
            return <ClienteForm formField={formField} rowData={rowDataConfirm}/>;
        default:
            return <div>Not Found</div>;
    }
}

function _renderStepContentPrevencion(activeStep, rowDataConfirm) {
    switch (activeStep) {
        case 0:
            return <PolizaFormPrevencion formField={formFieldPrevencion}/>
        case 1:
            return <ClienteFormPrevencion formField={formFieldPrevencion} rowData={rowDataConfirm}/>;
        default:
            return <div>Not Found</div>;
    }
}

function CotizacionesTable(props) {
    const classes = useStyles();

    // Adviser Context
    const {infoCotizaciones, handler, dateRange, productScope} = useContext(AdviserContext);
    const {coberturasInfo} = useContext(CotizarContext);
    const {authToken} = useContext(AuthContext);

    const [rows, setRows] = useState(null);
    const [openOtros, setOpenOtros] = useState(false);
    const [openPrevencion, setOpenPrevencion] = useState(false);
    const [openDateRange, setOpenDateRange] = useState(false);
    const [componentDateRange, setComponentDateRange] = useState([
        {
            startDate: dateRange['startDate'],
            endDate: dateRange['endDate'],
            key: 'selection'
        }
    ]);
    const [quitarCombinado] = useMutation(QUITAR_COTIZACION_COMBINADO);
    const [quitarMicroseguro] = useMutation(QUITAR_COTIZACION_MICROSEGURO);
    const [quitarAutomotor] = useMutation(QUITAR_COTIZACION_AUTOMOTOR);
    const [quitarMotovehiculo] = useMutation(QUITAR_COTIZACION_MOTOVEHICULO);
    const [quitarOtros] = useMutation(QUITAR_COTIZACION_OTROS);
    const [quitarPrevencion] = useMutation(QUITAR_COTIZACION_PREVENCION);

    //pagination
    const [page, setPage] = useState(1)
    const [displayLength, setDisplayLength] = useState(10)

    //sortable
    const [sortColumn, setSortColumn] = useState('')
    const [sortType, setSortType] = useState('')
    const [loading, setLoading] = useState(false)

    function handleSortColumn(sortColumn, sortType) {
        setLoading(true)
        setTimeout(() => {
            setSortColumn(sortColumn)
            setSortType(sortType)
            setLoading(false)
        }, 500);
    }

    //filtrar
    const [filtro, setFiltro] = useState(null);

    function remove(cotizacion) {
        switch (cotizacion['producto']) {
            case 'MOTOVEHICULO':
                quitarMotovehiculo({variables: {id: cotizacion.idCotizacion}}).then(() => {
                    setOpen(!open)
                    setRows(null)
                    handler([componentDateRange[0]['startDate'], componentDateRange[0]['endDate']])
                })
                break;
            case 'HOGAR':
                quitarCombinado({variables: {id: cotizacion.id}}).then(() => {
                    setOpen(!open)
                    setRows(null)
                    handler([componentDateRange[0]['startDate'], componentDateRange[0]['endDate']])
                })
                break;
            case 'AUTOMOTOR':
                quitarAutomotor({variables: {id: cotizacion.idCotizacion}}).then(() => {
                    setOpen(!open)
                    setRows(null)
                    handler([componentDateRange[0]['startDate'], componentDateRange[0]['endDate']])
                })
                break;
            case 'MICROSEGURO':
                quitarMicroseguro({variables: {id: cotizacion.id}}).then(() => {
                    setOpen(!open)
                    setRows(null)
                    handler([componentDateRange[0]['startDate'], componentDateRange[0]['endDate']])
                })
                break;
            case 'OTROS':
                quitarOtros({variables: {id: cotizacion.id}}).then(() => {
                    setOpen(!open)
                    setRows(null)
                    handler([componentDateRange[0]['startDate'], componentDateRange[0]['endDate']])
                })
                break;
            case 'PREVENCION SALUD':
                quitarPrevencion({variables: {id: cotizacion.id}}).then(() => {
                    setOpen(!open)
                    handler([componentDateRange[0]['startDate'], componentDateRange[0]['endDate']])
                    handler()
                })
                break;
        }
    }

    function getData() {
        if (sortColumn && sortType) {
            return sortRowsByType(rows, sortColumn, columnType[sortColumn], sortType)
                .filter((v, i) => {
                const start = displayLength * (page - 1);
                const end = start + displayLength;
                return i >= start && i < end;
            });
        } else {
            if (filtro) {
                let temp = rows.filter(e => e['producto'].includes(filtro))
                return temp.filter((v, i) => {
                    const start = displayLength * (page - 1);
                    const end = start + displayLength;
                    return i >= start && i < end;
                });
            } else {
                return rows.filter((v, i) => {
                    const start = displayLength * (page - 1);
                    const end = start + displayLength;
                    return i >= start && i < end;
                });
            }
        }
    }

    //CONFIRM OTROS EMISSION
    const steps = ['Póliza', 'Cliente'];
    const [activeStep, setActiveStep] = useState(0);
    const [rowDataConfirm, setRowDataConfirm] = useState('');
    const currentValidationSchema = validationSchema[activeStep];
    const formRef = useRef()
    const {handleModified} = useContext(IndicatorsContext)

    async function _submitForm(values, actions) {
        setRows(null)
        let url = process.env.REACT_APP_BACK_SERVER + '/emitir/otros';
        let valuesSend = {}

        valuesSend.origen = 'affinity';
        valuesSend.clientes = [{
            "sexo": values.sexo,
            "fechaNacimiento": values.fechaNacimiento,
            "cuit": values.cuit,
            "domicilio": ""
        }]
        valuesSend.premium = values.premium;
        valuesSend.numeroReferencia = values.numeroReferencia;
        valuesSend.estado = "Exitoso";
        valuesSend.afinidad = rowDataConfirm.idAfinidad;
        valuesSend.id = rowDataConfirm.id;
        valuesSend.producto = rowDataConfirm.Producto.idProducto;

        axios.post(url, {...valuesSend, ...{saveToDatabase: true}}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }
        }).then(res => {
            console.log(res);

            handleModified()
            handler([componentDateRange[0]['startDate'], componentDateRange[0]['endDate']])

            let jsonData = {
                'clientes': rowDataConfirm.Clientes,
                'afinidad': rowDataConfirm.idAfinidad,
                'referenceNumber': values.numeroReferencia,
                'premium': values.premium,
            };
            //SEND MAILS
            axios.post(process.env.REACT_APP_BACK_SERVER + '/sendOtrosEmail', jsonData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                }
            })
                .then((response) => {
                    actions.setSubmitting(false)
                    _handleCloseModal()
                })
                .catch((error) => {
                    alert("Hubo un error durante el envío de mails: " + error)
                });
        }).catch(err => {
            actions.setSubmitting(false)
            console.log(err);
        });
    }

    function _handleSubmit(values, actions) {
        actions.setSubmitting(true)
        if (activeStep > 0) {
            _handleCloseModal()
            _submitForm(values, actions);
            actions.resetForm()
        } else {
            setActiveStep(activeStep + 1);
            actions.setSubmitting(false);
        }
    }

    function _handleCloseModal() {
        if (formRef.current) {
            formRef.current.resetForm()
        }
        setActiveStep(0)
        setOpenOtros(false)
    }

    //CONFIRM PREVENCION EMISSION
    const stepsPrevencion = ['Póliza', 'Cliente'];
    const currentValidationSchemaPrevencion = validationSchemaPrevencion[activeStep];
    const prevencionFormRef = useRef();

    async function _submitPrevencionForm(values, actions) {
        setRows(null)
        let url = process.env.REACT_APP_BACK_SERVER + '/emitir/prevencion';
        let valuesSend = {
            "clientes": [{
                "cuit": values.cuit,
                "sexo": values.sexo,
                "dni": values.dni,
            }],
            "premium": values.premium,
            "numeroSolicitud": values.numeroSolicitud,
            "afinidad": rowDataConfirm.id_afinidad,
            "id": rowDataConfirm.id,
            "tipoAfiliacion": values.tipoAfiliacion,
            "cantidadCapitas": values.cantidadCapitas
        }

        axios.post(url, {...valuesSend, ...{saveToDatabase: true}}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }
        }).then(res => {
            console.log(res);
            handleModified()
            handler([componentDateRange[0]['startDate'], componentDateRange[0]['endDate']])
        }).catch(err => {
            actions.setSubmitting(false)
            console.log(err);
        });
    }

    function _handleSubmitPrevencion(values, actions) {
        actions.setSubmitting(true)
        if (activeStep > 0) {
            _handleCloseModalPrevencion()
            _submitPrevencionForm(values, actions);
            actions.resetForm()
        } else {
            setActiveStep(activeStep + 1);
            actions.setSubmitting(false);
        }
    }

    function _handleCloseModalPrevencion() {
        if (prevencionFormRef.current) {
            prevencionFormRef.current.resetForm()
        }
        setActiveStep(0)
        setOpenPrevencion(false)
    }

    //SEARCH
    const [filteredEmisiones, setFilteredEmisiones] = useState(null);

    const handleSearchValueChange = (event) => {
        if (event.target.value.length >= 3) {
            let filtered = rows.filter((item) =>
                item["Afinidad"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["Cliente_Completo"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["descripcion"].toUpperCase().includes(event.target.value.toUpperCase())
                || (item["idCotizacion"]+'').indexOf(event.target.value) > -1
            );
            setFilteredEmisiones(filtered);
        } else setFilteredEmisiones(null)
    };

    //TABLE ACTION BUTTONS
    const [open, setOpen] = useState(false);
    const [cotizacion, setCotizacion] = useState('');
    const history = useHistory();

    function handleAction(action, rowData) {
        switch (rowData['producto']) {
            case 'AUTOMOTOR':
                history.push({
                    pathname: '/u/cotizar/vehiculo',
                    state: {
                        data: rowData,
                        action: action
                    }
                })
                break;
            case 'MOTOVEHICULO':
                history.push({
                    pathname: '/u/cotizar/motovehiculo',
                    state: {
                        data: rowData,
                        action: action
                    }
                })
                break;
            case 'HOGAR':
                history.push({
                    pathname: '/u/cotizar/combinado',
                    state: {
                        data: rowData,
                        action: action
                    }
                })
                break;
            case 'MICROSEGURO':
                history.push({
                    pathname: '/u/cotizar/microseguro',
                    state: {
                        data: rowData,
                        action: action
                    }
                })
                break;
        }
    }

    function handleConfirm(rowData) {
        history.push({
            pathname: '/u/confirmar/vehiculo',
            state: {
                data: rowData
            }
        })
    }

    function handleQuitar(rowData) {
        setOpen(!open)
        setCotizacion(rowData)
    }

    function handleEmitirOtros(rowData) {
        setRowDataConfirm(rowData)
        setOpenOtros(true)
    }

    function handleEmitirPrevencion(rowData) {
        setRowDataConfirm(rowData)
        setOpenPrevencion(true)
    }

    const renderMenu = (rowData) => {
        const handleSelect = eventKey => {
            switch (eventKey) {
                case 0:
                    handleAction('recotizar', rowData)
                    break;
                case 1:
                    handleAction('emitir', rowData)
                    break;
                case 2:
                    handleQuitar(rowData)
                    break;
                case 3:
                    handleConfirm(rowData)
                    break;
                case 4:
                    handleAction('retomar', rowData)
                    break;
                case 5:
                    handleEmitirOtros(rowData)
                    break;
                case 6:
                    handleEmitirPrevencion(rowData)
                    break;
            }
        };

        //This condition will later be simplified when the other "confirmar" methods are included
        if (rowData['producto'] === "OTROS" || rowData['producto'] === "PREVENCION SALUD") {
            return (
                <Popover full>
                    <Dropdown.Menu placement="rightEnd" onSelect={handleSelect}>
                        <Dropdown.Item eventKey={rowData['producto'] === "OTROS" ? 5 : 6}>Emitir</Dropdown.Item>
                        <Dropdown.Item eventKey={2}>Quitar</Dropdown.Item>
                    </Dropdown.Menu>
                </Popover>
            );
        } else if (rowData['producto'] === "AUTOMOTOR") {
            //This is a temporal solution to migrate to a new discounts logic
            if (rowData['DescuentoCliente'] !== null || rowData.Estado !== 'Success') {
                return (<Popover full>
                    <Dropdown.Menu placement="rightEnd" onSelect={handleSelect}>
                        <Dropdown.Item eventKey={4}>Cotizar</Dropdown.Item>
                    </Dropdown.Menu>
                </Popover>)
            } else {
                return (
                    <Popover full>
                        <Dropdown.Menu placement="rightEnd" onSelect={handleSelect}>
                            <Dropdown.Item eventKey={0}>Recotizar</Dropdown.Item>
                            <Dropdown.Item eventKey={1}>Emitir</Dropdown.Item>
                            <Dropdown.Item eventKey={2}>Quitar</Dropdown.Item>
                            <Dropdown.Item eventKey={3}>Confirmar</Dropdown.Item>
                        </Dropdown.Menu>
                    </Popover>)}
        } else {
            return (
                <Popover full>
                    <Dropdown.Menu placement="rightEnd" onSelect={handleSelect}>
                        <Dropdown.Item eventKey={0}>Recotizar</Dropdown.Item>
                        <Dropdown.Item eventKey={1}>Emitir</Dropdown.Item>
                        <Dropdown.Item eventKey={2}>Quitar</Dropdown.Item>
                    </Dropdown.Menu>

                </Popover>
            );
        }
    };

    const ActionCell = ({rowData, dataKey, ...props}) => {
            return (
                <Cell {...props} className="link-group">
                    <Whisper placement="autoVerticalStart" trigger="click" speaker={renderMenu(rowData)}>
                        <ArrowDropDownCircleIcon style={{color: "#BB0D66", cursor: "pointer"}}/>
                    </Whisper>
                </Cell>
            );
        }
    ;

    useEffect(() => {
        setPage(1)
        if (filteredEmisiones === null)
            setRows(infoCotizaciones)
        else
            setRows(filteredEmisiones);
    }, [filteredEmisiones, infoCotizaciones]);

    const opcionesMenu = [
        {eventKey: "AUTOMOTOR", label: "Automotor", scopeName: "vehiculo"},
        {eventKey: "MICROSEGURO", label: "Microseguro", scopeName: "microseguro"},
        {eventKey: "HOGAR", label: "Hogar", scopeName: "combinado"},
        {eventKey: "OTROS", label: "Otros", scopeName: "otros"},
        {eventKey: "PREVENCION SALUD", label: "Prevención Salud", scopeName: "prevencion"},
        {eventKey: "MOTOVEHICULO", label: "Motovehículo", scopeName: "motovehiculo"}
    ];

    const MenuPopover = ({onSelect, ...rest}) => {
        const opcionesFiltradas = opcionesMenu.filter(opcion => {
            return productScope.includes(opcion['scopeName'])
        });

        return (
            <Popover {...rest} full>
                <Dropdown.Menu onSelect={onSelect} title="Producto" placement="bottomEnd" activeKey={filtro}>
                    <Dropdown.Item eventKey={null} onSelect={(eventKey) => setFiltro(eventKey)}>Sin filtro</Dropdown.Item>
                    {opcionesFiltradas.map(opcion => (
                        <Dropdown.Item
                            key={opcion.eventKey}
                            eventKey={opcion.eventKey}
                            onSelect={(e) => {
                                setFiltro(e)
                            }}
                        >
                            {opcion.label}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Popover>
        );
    };

    return (
        <React.Fragment>
            <div style={{display: 'flex', flexDirection: 'column', width: "100%"}}>

                {!rows
                    ? <Loading/>
                    : <>
                        <div className={classes.tableHeader}>
                            <h3 className={classes.tableTitle}>Mis últimas cotizaciones</h3>
                            <div className={classes.endHorizontally}>
                                <div className={classes.centerVertically} style={{marginRight: "8px"}}><SearchIcon
                                    style={{color: "#BB0D66"}}/></div>
                                <div className={classes.centerVertically} style={{marginTop: "-24px"}}>
                                    <TextField
                                        label="Buscar"
                                        className={classes.alertField}
                                        onChange={(e) => handleSearchValueChange(e)}/>
                                </div>
                                <div className={classes.centerVertically}>
                                    <IconButton onClick={() => setOpenDateRange(true)}>
                                        <CalendarTodayIcon style={{color: "#bb0d66"}}/>
                                    </IconButton>
                                </div>
                            </div>
                        </div>


                        < Table
                            height={400}
                            width={980}
                            data={getData()}
                            // Sortable
                            sortColumn={sortColumn}
                            sortType={sortType}
                            loading={loading}
                            onSortColumn={(sortColumn, sortType) => handleSortColumn(sortColumn, sortType)}
                        >
                            <Column width={80}>
                                <HeaderCell>id Cotizacion</HeaderCell>
                                <Cell dataKey="idCotizacion"/>
                            </Column>
                            <Column width={120} sortable>
                                <HeaderCell>Última modificación</HeaderCell>
                                <Cell dataKey="FechaModificacion"/>
                            </Column>
                            <Column width={100} sortable>
                                <HeaderCell>Estado</HeaderCell>
                                <Cell dataKey="Estado"/>
                            </Column>
                            <Column width={100} resizable>
                                <HeaderCell>Affinity</HeaderCell>
                                <Cell dataKey="Afinidad"/>
                            </Column>
                            <Column width={180} resizable>
                                <HeaderCell>Cliente</HeaderCell>
                                <ClienteCell dataKey="Cliente_Completo"/>
                            </Column>

                            <Column width={160}>
                                <HeaderCell>
                                    <Whisper
                                        trigger="click"
                                        speaker={<MenuPopover/>}
                                    >
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            cursor: 'pointer',
                                            alignItems: 'center'
                                        }}>
                                            <FontAwesomeIcon icon={faChevronCircleDown} style={{
                                                color: '#6e6e72',
                                                fontSize: '12px',
                                                textAlign: 'center',
                                                marginRight: '6px'
                                                // marginRight: '20px'
                                            }}/>
                                            <p>Producto</p>
                                        </div>
                                    </Whisper>
                                </HeaderCell>
                                <Cell dataKey="producto"/>
                            </Column>

                            <Column width={260} resizable>
                                <HeaderCell>Descripción</HeaderCell>
                                <NameCell dataKey="descripcion" coberturasInfo={coberturasInfo}/>
                            </Column>

                            <Column width={130} sortable>
                                <HeaderCell>Fecha Cotización</HeaderCell>
                                <Cell dataKey="FechaCotizacion"/>
                            </Column>

                            <Column width={140}>
                                <HeaderCell>Compartir</HeaderCell>

                                <Cell>
                                    {rowData => {
                                        return (
                                            <span>
                                        {rowData.Clientes !== null
                                            ?
                                            <>
                                                <button className={classes.shareButton} onClick={
                                                    () => {
                                                        // TODO: Remove conditional, the right one will be the one with splitted field
                                                        rowData.Clientes.CodArea !== null && rowData.Clientes.CodArea !== undefined
                                                            ? sendWapp("https://wa.me/" + "549" + rowData.Clientes.CodArea + rowData.Clientes.Telefono + "?text=¡Buenos%20días%20" + rowData.Clientes.Nombre + "!%20Le%20comparto%20la%20información%20de%20la%20cotización%20solicitada.%20Cualquier%20consulta,%20no%20dude%20en%20escribirme.%20Saludos!")
                                                            : sendWapp("https://wa.me/" + "549" + rowData.Clientes.Telefono + "?text=¡Buenos%20días%20" + rowData.Clientes.Nombre + "!%20Le%20comparto%20la%20información%20de%20la%20cotización%20solicitada.%20Cualquier%20consulta,%20no%20dude%20en%20escribirme.%20Saludos!")
                                                    }}>
                                                    WhatsApp
                                                </button>

                                                <Mailto email={rowData.Clientes.Email}
                                                        subject="La cotización de su seguro está lista"
                                                        body={"¡Buenos días " + rowData.Clientes.Nombre + "! Le comparto la información de la cotización que ha solicitado. Cualquier consulta, quedo a su disposición. Saludos."}>
                                                    <button className={classes.shareButton}>Mail</button>
                                                </Mailto>
                                            </>

                                            : "Sin Datos"
                                        }
                      </span>
                                        );
                                    }}
                                </Cell>
                            </Column>
                            <Column fixed="right" width={50} align="center">
                                <HeaderCell/>
                                <ActionCell dataKey="id"/>
                            </Column>

                        </Table>
                        <Pagination
                            lengthMenu={[
                                {
                                    value: 10,
                                    label: 10
                                },
                                {
                                    value: 20,
                                    label: 20
                                }
                            ]}
                            activePage={page}
                            displayLength={displayLength}
                            total={rows.length}
                            onChangePage={(dataKey) => setPage(dataKey)}
                            onChangeLength={(dataKey) => setDisplayLength(dataKey)}
                        /></>
                }

                <Modal backdrop={true} show={open} onHide={() => setOpen(!open)} style={{top: '10%'}}>
                    <Modal.Header>

                    </Modal.Header>
                    <Modal.Body>
                        <div className={classes.modalColumn}>
                            <p className={classes.modalTitle}>¿Está seguro que desea quitar la siguiente cotización?</p>
                            <div>
                                <p className={classes.modalSubtitle}> Afinidad </p>
                                <p className={classes.modalText}>  {cotizacion['Afinidad']}  </p>
                                <p className={classes.modalSubtitle}> Cliente </p>
                                <p className={classes.modalText}>  {cotizacion['Cliente_Completo']}  </p>
                                <p className={classes.modalSubtitle}> Descripción </p>
                                <p className={classes.modalText}>  {cotizacion['descripcion']}  </p>
                                <p className={classes.modalSubtitle}> Fecha de cotización </p>
                                <p className={classes.modalText}>  {cotizacion['FechaCotizacion']} </p>
                            </div>
                            <div style={{marginTop: "8px"}}>
                                <Button className={classes.btnCancel} onClick={() => setOpen(!open)}>
                                    Cancelar
                                </Button>
                                <Button className={classes.btnShare} onClick={() => remove(cotizacion)}>
                                    Confirmar
                                </Button>
                            </div>

                        </div>
                    </Modal.Body>
                </Modal>

                <Modal backdrop={true} size="xs" show={openDateRange} onHide={() => setOpenDateRange(!openDateRange)} style={{top: '10%'}}>
                    <Modal.Header>
                        <div className={classes.iconCircle}>
                            <CalendarTodayIcon style={{color: "#FFF"}}/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={classes.modalColumn}>
                            <div>
                                    <p className={classes.dateRangeTitle}>Rango de fechas</p>
                                    <DateRangePicker
                                        onChange={item => {
                                            setComponentDateRange([item.selection])
                                        }}
                                        showSelectionPreview={true}
                                        moveRangeOnFirstSelection={false}
                                        months={1}
                                        rangeColors={["#bb0d66"]}
                                        ranges={componentDateRange}
                                        locale={locales["es"]}
                                        direction="horizontal"
                                        inputRanges={[]}
                                        staticRanges={[]}
                                        minDate={new Date("01-01-2020")}
                                        maxDate={new Date()}
                                    />
                            </div>
                            <div className={classes.buttonModalContainer}>
                                <Button
                                    variant="contained"
                                    type="button"
                                    color="primary"
                                    className={classes.buttonConfirm}
                                    onClick={() => {
                                        setRows(null)
                                        handler([componentDateRange[0]['startDate'], componentDateRange[0]['endDate']])
                                        setOpenDateRange(!openDateRange)
                                    }}
                                >
                                    Confirmar
                                </Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                {rowDataConfirm && openPrevencion &&
                <CustomModal show={openPrevencion} handleClose={_handleCloseModalPrevencion}>
                    <div style={{padding: "24px"}}>
                        <div className={classes.iconCircle} style={{marginTop: "-104px"}}>
                            <img src={prevencion_white_icon} style={{width: "28px", height: "auto"}}/>
                        </div>
                        <div style={{margin: "24px 0"}}>
                            <ProgressBar activeStep={activeStep} stepTitles={stepsPrevencion}/>
                        </div>

                        <Fragment>
                            <Formik
                                enableReinitialize={true}
                                initialValues={{
                                    ...formInitialValuesPrevencion,
                                    "dni": rowDataConfirm['Clientes']['DNI'],
                                    "tipoAfiliacion": rowDataConfirm['condicion_laboral'], //Same as condicionLaboral on CD module
                                    "cantidadCapitas": rowDataConfirm['cantidad_hijos'] + 1 + parseInt(rowDataConfirm['carga_familiar']), //Sons + him/her + husband/wife
                                }}
                                validationSchema={currentValidationSchemaPrevencion}
                                validateOnBlur={false}
                                onSubmit={_handleSubmitPrevencion}
                                innerRef={prevencionFormRef}
                            >
                                {({isSubmitting}) => (
                                    <Form id={"prevencionEmitirForm"}>
                                        {_renderStepContentPrevencion(activeStep, rowDataConfirm)}
                                        <div className={classes.buttons}>
                                            <Button
                                                disabled={isSubmitting}
                                                variant="contained"
                                                type="submit"
                                                color="primary"
                                                className={classes.buttonConfirm}
                                            >
                                                {activeStep > 0 ? "Confirmar Emisión" : "Siguiente"}
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Fragment>
                    </div>
                </CustomModal>}

                {rowDataConfirm && openOtros &&
                <CustomModal show={openOtros} handleClose={_handleCloseModal}>
                    <div style={{padding: "24px"}}>
                        <div className={classes.iconCircle} style={{marginTop: "-104px"}}>
                            <img src={white_others_icon} style={{width: "40px", height: "auto"}}/>
                        </div>
                        <div style={{margin: "24px 0"}}>
                            <ProgressBar activeStep={activeStep} stepTitles={steps}/>
                        </div>

                        <Fragment>
                            <Formik
                                enableReinitialize={true}
                                initialValues={formInitialValues}
                                validationSchema={currentValidationSchema}
                                validateOnBlur={false}
                                onSubmit={_handleSubmit}
                                innerRef={formRef}
                            >
                                {({isSubmitting}) => (
                                    <Form id={formId}>
                                        {_renderStepContent(activeStep, rowDataConfirm)}
                                        <div className={classes.buttons}>
                                            <Button
                                                disabled={isSubmitting}
                                                variant="contained"
                                                type="submit"
                                                color="primary"
                                                className={classes.buttonConfirm}
                                            >
                                                {activeStep > 0 ? "Confirmar Emisión" : "Siguiente"}
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Fragment>
                    </div>
                </CustomModal>
                }
            </div>
        </React.Fragment>
    );
}

export default CotizacionesTable;
